export default {
  navHome: "Home",
  navProducts: "Prodotti",
  navCases: "Casi applicativi",
  navAbout: "Chi siamo",
  deliverTo: "Consegna a:",
  langCurrencyLabel: "Italiano",
  localeLangTitle: "Imposta lingua",
  localeLangDesc:
    "Seleziona la lingua preferita. Puoi aggiornare questa impostazione in qualsiasi momento.",
  language: "Lingua",
  save: "Salva",
  coreProducts: "Dare vita alla creatività nel mondo reale.",
  coreProductsDesc:
    "Dall'idea al business �?YONGYUAN offre stampanti UV, stampanti per etichette cristallo, stampanti cilindriche ad alta velocità, stampanti DTF e DTG, trasformando la creatività in prodotti, marchi e opportunità.",
  scenariosTitle: "Soluzioni per ogni scenario",
  scenariosDesc:
    "Che tu stia costruendo un marchio, sviluppando un'attività secondaria o seguendo passioni creative, YONGYUAN offre una soluzione su misura per le tue esigenze.",
  scenarioStudio: "Studio",
  scenarioStudioDesc:
    "Personalizzazione di alto valore, prototipazione in piccoli lotti e costruzione del marchio",
  scenarioRetail: "Retail di marca",
  scenarioRetailDesc:
    "Aumentare il tempo di permanenza e i ricavi in negozio",
  scenarioMarket: "Mercato ambulante",
  scenarioMarketDesc:
    "Personalizzazione sul posto, vendita di prodotti finiti e reddito extra",
  scenarioEnterprise: "Personalizzazione aziendale",
  scenarioEnterpriseDesc:
    "Personalizzazione in serie, merchandising di marca e regali aziendali",
  scenarioEcommerce: "Vendita in livestream",
  scenarioEcommerceDesc:
    "Campioni di prodotti di successo, fornitura flessibile e lanci rapidi",
  scenarioStore: "Negozio online",
  scenarioStoreDesc:
    "Personalizzazione del negozio, merchandising di successo e operazioni differenziate",
  scenarioFactory: "Produzione in fabbrica",
  scenarioFactoryDesc:
    "Produzione in serie, output stabile e operazioni efficienti",
  scenarioAdvertising: "Produzione pubblicitaria",
  scenarioAdvertisingDesc:
    "Segnaletica, materiali espositivi e materiali per eventi",
  industries: "Applicazioni industriali",
  industriesDesc:
    "Soluzioni di stampa a getto d'inchiostro digitale per la stampa a colori in diversi settori.",
  applicationsTitle:
    "Sblocca applicazioni versatili di materiali e colori per esigenze quotidiane e commerciali.",
  applicationsDesc:
    "Le attrezzature di stampa UV YONGYUAN sono progettate per un'ampia gamma di materiali e scenari di processo, consentendo personalizzazione e produzione su larga scala.",
  casesHeroDesc:
    "Oltre 1200 applicazioni di settore e decine di migliaia di materiali stampabili: soluzioni di stampa digitale per ogni tipo di business.",
  casesBreadcrumbHome: "Home",
  casesBreadcrumbCenter: "Casi applicativi",
  casesEmpty: "Nessun caso applicativo in questa categoria al momento.",
  customerStoriesTitle: "Scelto da clienti in tutto il mondo",
  customerStoriesSubtitle:
    "Installazioni reali, clienti reali, attività di stampa reali in 172 paesi.",
  customerStoriesStat1Value: "53.000+",
  customerStoriesStat1Label: "Stampanti consegnate",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Paesi serviti",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Anni di esperienza",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Supporto tecnico",
  customerStoriesPlaceholder: "Aggiungi foto cliente",
  customerStoriesPhotoAlt: "Cliente YONGYUAN con stampante",
  servicePartnerTitle:
    "Conosci il team di servizio YONGYUAN, il tuo partner creativo",
  servicePartnerDesc:
    "Una rete di servizio globale e un sistema di supporto professionale per proteggere le prestazioni del tuo equipaggiamento e la crescita del tuo business.",
  serviceSupportTitle: "Supporto standard",
  serviceSupportDesc:
    "Guida all'installazione, formazione di base e assistenza quotidiana per un funzionamento affidabile dell'equipaggiamento.",
  servicePresaleTitle: "Demo e consulenza pre-vendita",
  servicePresaleDesc:
    "Dimostrazioni di soluzioni e raccomandazioni di modelli adattate ai tuoi scenari di applicazione e requisiti di capacità.",
  serviceLifetimeTitle: "Supporto tecnico a vita",
  serviceLifetimeDesc:
    "Risposta tecnica continua e supporto ai processi per accompagnare lo sviluppo a lungo termine del tuo business.",
  serviceCareTitle: "Passa a YONGYUAN Care",
  serviceCareDamageTitle: "Protezione dai danni accidentali",
  serviceCareDamageDesc:
    "Un piano di protezione più completo per ridurre le perdite causate da incidenti imprevisti.",
  serviceCareExchangeTitle: "Servizio di permuta rapida",
  serviceCareExchangeDesc:
    "Accordi prioritari di permuta rapida in condizioni idonee per accelerare il recupero del capitale.",
  viewProduct: "Vedi prodotti",
  learnMore: "Scopri di più",
  catUv: "Stampante UV piano",
  catCylinder: "Stampante cilindrica",
  catCrystal: "Stampante etichetta cristallo",
  catDtf: "Stampante DTF",
  catDtg: "Stampante DTG",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Telefono: 17748697567 Manager Tang",
  email: "Email: sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. Tutti i diritti riservati",
  productsHeroTitle: "Prodotti",
  productsHeroDesc:
    "Linea completa di attrezzature UV piano, cilindriche, etichette cristallo, DTF e DTG per diverse esigenze di capacità e applicazione.",
  productsBreadcrumbHome: "Home",
  productsBreadcrumbCenter: "Prodotti",
  productsEmpty: "I prodotti di questa categoria saranno disponibili a breve.",
  productsQuoteTitle: "Richiedi soluzione e preventivo",
  productsQuoteDesc:
    "Condividi i tuoi scenari di applicazione e requisiti di capacità, e ti consiglieremo la soluzione di equipaggiamento più adatta.",
  productsContact: "Contattaci",
  aboutHeroTitle: "Chi è Yongyuan",
  aboutHeroDesc:
    "23 anni dedicati alla R&S e produzione di attrezzature di stampa UV",
  productA23Subtitle: "Stampante UV intelligente 6 colori da scrivania",
  productA23Feature1: "Formato di stampa A4",
  productA23Feature2: "Sistema intelligente di erogazione inchiostro",
  productA23Feature3: "Rilevamento automatico altezza a infrarossi",
  productA35Subtitle: "Stampante UV intelligente 6 colori da scrivania",
  productA35Feature1: "Formato di stampa A3+",
  productA35Feature2: "Sistema intelligente di erogazione inchiostro",
  productA35Feature3: "Rilevamento automatico altezza a infrarossi",
  productA43Subtitle: "Stampante UV intelligente 8 colori flagship",
  productA43Feature1: "Formato di stampa A3",
  productA43Feature2: "Configurazioni multiple testine di stampa",
  productA43Feature3: "Sistema intelligente di erogazione inchiostro",
  productA46Subtitle: "Stampante UV intelligente 8 colori flagship",
  productA46Feature1: "Formato di stampa A2",
  productA46Feature2: "Configurazioni multiple testine di stampa",
  productA46Feature3: "Sistema intelligente di erogazione inchiostro",
  productA57Subtitle: "Stampante UV intelligente 8 colori flagship",
  productA57Feature1: "Formato di stampa A2+",
  productA57Feature2: "Configurazioni multiple testine di stampa",
  productA57Feature3: "Sistema intelligente di erogazione inchiostro",
  productA69Subtitle: "Stampante UV intelligente 8 colori flagship",
  productA69Feature1: "Formato di stampa A1",
  productA69Feature2: "Configurazioni multiple testine di stampa",
  productA69Feature3: "Sistema intelligente di erogazione inchiostro",
  productA1216Subtitle: "Stampante UV piano grande formato flagship",
  productA1216Feature1: "Formato di stampa 1200×1600cm",
  productA1216Feature2: "Configurazioni multiple testine di stampa",
  productA1216Feature3: "Sistema di posizionamento visivo",
  productA2513Subtitle: "Stampante UV piano grande formato flagship",
  productA2513Feature1: "Formato di stampa 2500×1300cm",
  productA2513Feature2: "Configurazioni multiple testine di stampa",
  productA2513Feature3: "Sistema di posizionamento visivo",
  productCylinderElfSubtitle: "Stampante cilindrica ad alta velocità 360°",
  productCylinderElfFeature1: "Stampa 360°",
  productCylinderElfFeature2: "Personalizzazione tazze e bottiglie",
  productCylinderElfFeature3: "Cambio rapido attrezzature",
  productCupPlusSubtitle: "Soluzione di stampa multi-formato per tazze e bottiglie",
  productCupPlusFeature1: "Attrezzature multi-formato",
  productCupPlusFeature2: "Alta efficienza produttiva",
  productCupPlusFeature3: "Output stabile",
  productCrystal60Subtitle: "Sistema tutto-in-uno stampa e foil etichette cristallo",
  productCrystal60Feature1: "Larghezza 60cm",
  productCrystal60Feature2: "Integrazione stampa e foil",
  productCrystal60Feature3: "Sistema di raccolta efficiente",
  productCrystalC60UltraFeature1: "Larghezza 60 cm",
  productCrystalC60UltraFeature2: "Opzioni foil oro/argento/etichetta silicone 3D",
  productCrystalC60UltraFeature3: "Produzione di massa",
  productCrystal30Subtitle: "Stampante compatta alta precisione per etichette cristallo",
  productCrystal30Feature1: "Stampa di precisione compatta",
  productCrystal30Feature2: "Facile da usare",
  productCrystal30Feature3: "Personalizzazione individuale",
  productDtf60Subtitle: "Stampante trasferimento DTF inchiostro bianco",
  productDtf60Feature1: "Trasferimento DTF inchiostro bianco",
  productDtf60Feature2: "Strati di colore ricchi",
  productDtf60Feature3: "Accessori abbigliamento",
  productDtfF20Subtitle: "La stampante DTF a inchiostro bianco da desktop più compatta del settore",
  productDtfF20Feature1: "Formato A4",
  productDtfF20Feature2: "Personalizzazione in piccoli lotti",
  productDtfF20Feature3: "Sistema inchiostro intelligente",
  productDtfF30Subtitle: "Stampante DTF a inchiostro bianco da desktop",
  productDtfF30Feature1: "Formato A3",
  productDtfF30Feature2: "Testina singola manuale/automatica opzionale",
  productDtfF30Feature3: "Sistema inchiostro intelligente",
  productDtfF30ProSubtitle: "Stampante DTF a inchiostro bianco",
  productDtfF30ProFeature1: "Formato A3",
  productDtfF30ProFeature2: "Doppia testina con raccolta automatica pellicola",
  productDtfF30ProFeature3: "Sistema inchiostro intelligente",
  productDtfF33Subtitle: "Stampante DTF a inchiostro bianco",
  productDtfF33Feature1: "Formato A3",
  productDtfF33Feature2: "Testina singola manuale/automatica opzionale",
  productDtfF33Feature3: "Sistema inchiostro intelligente",
  productDtfF70ProSubtitle: "Stampante DTF a inchiostro bianco formato largo 70 cm",
  productDtfF70ProFeature1: "Formato A2",
  productDtfF70ProFeature2: "Opzioni 2�? testine di stampa",
  productDtfF70ProFeature3: "Sistema automatico di alimentazione e scarico",
  productDtfF70ProFeature4: "Modalità intelligente di ripresa stampa",
  productDtf30Subtitle: "Stampante DTF compatta inchiostro bianco",
  productDtf30Feature1: "Personalizzazione piccoli lotti",
  productDtf30Feature2: "Riproduzione colore accurata",
  productDtf30Feature3: "Facile da usare",
  productDtgPrintSubtitle: "Stampante digitale diretta su tessuto",
  productDtgPrintFeature1: "Stampa diretta multi-materiale",
  productDtgPrintFeature2: "Alto rendimento",
  productDtgPrintFeature3: "Stabile e durevole",
  productDtg3250DSubtitle: "Unico modello 2-in-1 DTF e DTG del settore",
  productDtg3250DFeature1: "Formato A3+",
  productDtg3250DFeature2: "Stampa dual-process DTF e DTG",
  productDtg3250DFeature3: "Sistema inchiostro intelligente",
  productDtg3646TSubtitle: "Stampante DTG a doppia postazione",
  productDtg3646TFeature1: "Modalità produzione continua",
  productDtg3646TFeature2: "Produttività aumentata del 100%",
  productDtg3646TFeature3: "Sistema inchiostro intelligente",
  productDtgMaxSubtitle: "Stampante DTG digitale industriale",
  productDtgMaxFeature1: "Capacità industriale",
  productDtgMaxFeature2: "Stabile e durevole",
  productDtgMaxFeature3: "Funzionamento continuo",
  app01Title: "Cover per telefono",
  app02Title: "Palline da golf",
  app03Title: "Targhe in pietra",
  app04Title: "Penne a sfera",
  app05Title: "Custodie per occhiali",
  app06Title: "Stampe su legno",
  app07Title: "Lattine di bevande",
  app08Title: "Tastiere",
  app09Title: "Borracce termiche",
  app10Title: "Bagagli",
  app11Title: "Prodotti in acrilico",
  app12Title: "Quaderni",
  app13Title: "Badge",
  app14Title: "Portacarte in pelle",
  app15Title: "Piastrine identificative",
  app16Title: "Arte su vetro",
  appDtgCase01: "Magliette",
  appDtgCase02: "Felpe con cappuccio",
  regionCn: "Cina",
  regionUs: "Stati Uniti",
  regionGb: "Regno Unito",
  regionDe: "Germania",
  regionAe: "EAU",
  regionIn: "India",
  regionJp: "Giappone",
  regionVn: "Vietnam",
  regionBr: "Brasile",
  regionAu: "Australia",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
